import React from 'react';
import cn from 'classnames';

export default ({ children, className = '' }) => (
	<div className={cn('md:container px-4 mx-auto overflow-visible', className)}>{children}</div>
);
